import { render, staticRenderFns } from "./electric-prepay-list.vue?vue&type=template&id=32dbeda5&scoped=true&"
import script from "./electric-prepay-list.vue?vue&type=script&lang=js&"
export * from "./electric-prepay-list.vue?vue&type=script&lang=js&"
import style0 from "./electric-prepay-list.vue?vue&type=style&index=0&id=32dbeda5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dbeda5",
  null
  
)

export default component.exports